// MUI base styles
import colors from "../../base/colors";
import boxShadows from "../../base/boxShadows";
import borders from "../../base/borders";

const {white, dark} = colors;
const {cardBoxShadow} = boxShadows;
const {borderRadius} = borders;

const tableContainer = {
    styleOverrides: {
        root: {
            color: dark.main,
            backgroundColor: white.main,
            boxShadow: cardBoxShadow,
            borderRadius: borderRadius.md,
        },
    },
};

export default tableContainer;
